/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const SidebarExpandedStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.6 19.4V4.6M5.5 7H7.5M5.5 10H7.5M5.5 13H7.5M21 17.6V6.4C21 5.07452 19.9255 4 18.6 4L5.4 4C4.07452 4 3 5.07452 3 6.4L3 17.6C3 18.9255 4.07452 20 5.4 20H18.6C19.9255 20 21 18.9255 21 17.6Z"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { SidebarExpandedStrokeIcon };
